import React from "react";
import { useDispatch } from "react-redux";
import { Grid, Type, Flex, Button } from "mesh-component-library";
import { useLocale } from "../../../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../../../app-consts/translations";
import { generatePath } from "../../../../utilities/RedirectUtils";
import { refreshReducersToInitial } from "../../../../action";
import { BaseServiceRequestPayload, CallOemPartialSaveRequestPayload, DeclinePartialSaveRequestPayload } from "../../types";

export type OemDeflectionScreenProps = {
  oemNumber: string;
  callId: string;
  partnerCode: string;
  serviceRequestPayload: BaseServiceRequestPayload;
  history: any;
  onCallOem: (payload: CallOemPartialSaveRequestPayload) => void;
  onContinue: (payload: DeclinePartialSaveRequestPayload) => void;
};

// Partner-agnostic OEM Deflection screen: presents the customer with the option to call
// their vehicle manufacturer about a warranty repair (Call OEM), or continue through the
// standard Digital Rescue flow (Continue / decline).
export const OemDeflectionScreen = ({
  oemNumber,
  callId,
  partnerCode,
  serviceRequestPayload,
  history,
  onCallOem,
  onContinue,
}: OemDeflectionScreenProps) => {
  const getTranslatedText = useLocale();
  const dispatch = useDispatch();

  const handleCallOemClick = () => {
    onCallOem({
      serviceRequestPayload,
      partnerCode,
      callId,
      oemNumber,
      history,
      dispatch: () => dispatch(refreshReducersToInitial()),
    });
    window.location.href = `tel:${oemNumber}`;
  };

  const handleContinueClick = () => {
    onContinue({
      serviceRequestPayload,
      partnerCode,
      history,
      dispatch: () => dispatch(refreshReducersToInitial()),
    });
    history.push(generatePath("home"));
  };

  return (
    <>
      <Grid utils={{ vrBottom: "md" }}>
        <Grid.Column>
          <Type element="h1" weight="semibold" align="left" size="6xl" lineHeight="md" utils={{ vrTop: "md" }}>
            {getTranslatedText(TRANSLATION_CONSTANTS.WARRANTY_DEFLECTION_TITLE)}
          </Type>
        </Grid.Column>
      </Grid>
      <Grid utils={{ vrBottom: "md" }}>
        <Grid.Column>
          <Type element="p">{getTranslatedText(TRANSLATION_CONSTANTS.WARRANTY_DEFLECTION_DESCRIPTION_PART_ONE)}</Type>
          <Type element="p">{getTranslatedText(TRANSLATION_CONSTANTS.WARRANTY_DEFLECTION_DESCRIPTION_PART_TWO)}</Type>
        </Grid.Column>
      </Grid>
      <Grid utils={{ vrBottom: "md" }}>
        <Grid.Column>
          <Flex justifyContent="between">
            <Button
              hasUpgrade
              onClick={handleCallOemClick}
              data-testid="call-oem-button"
              utils={{ fullWidth: true }}
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CALL)}
            </Button>
          </Flex>
        </Grid.Column>
      </Grid>
      <Grid utils={{ vrBottom: "md" }}>
        <Grid.Column>
          <Button
            hasUpgrade
            onClick={handleContinueClick}
            data-testid="oem-deflection-continue-button"
            utils={{ fullWidth: true }}
          >
            {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE)}
          </Button>
        </Grid.Column>
      </Grid>
    </>
  );
};
